export function capitalizeWords(str: string | undefined) {
    try {
        return (str || "")
            .toLocaleLowerCase("tr-TR")
            .split(" ")
            .map((word) => (word ? word[0].toLocaleUpperCase("tr-TR") + word.slice(1) : ""))
            .join(" ");
    } catch (err) {
        return "";
    }
}

export const splitPlate = (plate: string) => {
    const regex = /^(0[1-9]|[1-7][0-9]|8[01])\s?([a-zA-Z]{1,3})\s?(\d{2,5})$/;

    const match = plate && plate.match(regex);

    if (match) {
        const provinceCode = match[1]; // Matches the province code (e.g., 34)
        const letterSection = match[2]; // Matches the letter section (e.g., HZS)
        const numberSection = match[3]; // Matches the number section (e.g., 966)

        return `${provinceCode} ${letterSection} ${numberSection}`;
    } else {
        return plate;
    }
};

export function uppercaseWords(str: string) {
    return str
        .toLocaleLowerCase("tr-TR")
        .split("")
        .map((word) => word[0].toLocaleUpperCase("tr-TR"))
        .join("");
}
export async function copyToClipboard(text: string) {
    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch (err) {
        console.error("Failed to copy: ", err);
        return false;
    }
}

export function decodeArrayBufferToString(buffer: ArrayBuffer): string {
    const decoder = new TextDecoder("utf-8");
    const res = decoder.decode(buffer);
    return (res && (JSON.parse(res) as { message: string })?.message) || "";
}

export function formatFlightNumber(flightNumber: string): string {
    if (!flightNumber) return "";

    try {
        const formatted = flightNumber
            .trim()
            .replace(/^([A-Z]+)\s*(\d+)$/, "$1-$2")
            .toUpperCase(); // Match airline code and flight number, with space between

        return formatted.length > 8 ? flightNumber : formatted;
    } catch (err) {
        return "";
    }
}

export function stringToColor(str: string, prc: number = -20): string {
    // Ensure prc is within the range [-100, 100]
    prc = Math.max(-100, Math.min(100, prc));

    // Generate a Hash for the String
    const hash = (word: string): number => {
        let h = 0;
        for (let i = 0; i < word.length; i++) {
            h = word.charCodeAt(i) + ((h << 5) - h);
        }
        return h;
    };

    // Change the darkness or lightness
    const shade = (color: string, prc: number): string => {
        const num = parseInt(color, 16);
        const amt = Math.round(2.55 * prc);
        const R = (num >> 16) + amt;
        const G = ((num >> 8) & 0x00ff) + amt;
        const B = (num & 0x0000ff) + amt;

        return (
            0x1000000 +
            (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
            (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
            (B < 255 ? (B < 1 ? 0 : B) : 255)
        )
            .toString(16)
            .slice(1);
    };

    // Convert the hash value to a RGB hex string
    const int_to_rgba = (i: number): string => {
        const color = ((i >> 16) & 0xff).toString(16) + ((i >> 8) & 0xff).toString(16) + (i & 0xff).toString(16);
        return color;
    };

    return shade(int_to_rgba(hash(str)), prc);
}
